import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';
export const ALERT_SUBSCRIPTION_INACTIVE_SHOP: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translate: false,
  },
  message: {
    message: 'custom.subscription_inactive_shop',
    translate: true,
  },
};
